import { getEnv } from "../../lib/env";
export const exit = async () => {
    const token = localStorage.getItem("sw_user_token");

    if (token) {
        try {
            await fetch(getEnv('REACT_APP_BASE_URL') + "/logout", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token,
                    "Accept": "application/json",
                },
            });
        } catch (error) {
            console.error("Logoutda xatolik:", error);
        }
    }

    // Serverdan javob kelsa-kelmasa, brauzerni tozalaymiz
    localStorage.removeItem("sw_user");
    localStorage.removeItem("sw_user_token");
    
    // Foydalanuvchini login sahifasiga qaytaramiz
    window.location.href = "/";
}